import * as Sentry from '@sentry/angular';
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  isDevMode,
  ErrorHandler,
  provideAppInitializer,
  inject,
} from '@angular/core';
import {
  provideRouter,
  Router,
  withInMemoryScrolling,
} from '@angular/router';

import { routes } from './app.routes';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { TranslocoHttpLoader } from './transloco-loader';
import { authenticationInterceptor } from './core/security/interceptors/authentication.interceptor';
import { trackingIdInterceptor } from './core/security/interceptors/tracking-id.interceptor';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { provideTransloco } from '@jsverse/transloco';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { MetaPixelService } from './core/services/analytics/meta-pixel.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authenticationInterceptor, trackingIdInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    provideToastr(),
    provideAnimations(),
    provideHttpClient(withFetch()),
    provideTransloco({
      config: {
        availableLangs: ['en', 'fr'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoMessageformat({
      locales: ['en', 'fr'],
    }),
    provideClientHydration(withEventReplay()),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
      inject(MetaPixelService).init();
    }),
  ],
};
